import { inject, IEventAggregator, bindable } from 'aurelia';
import { LocaleChanged } from '../../messages/locale-changed';

@inject(Element, IEventAggregator)
export class ToolTipCustomAttribute {
  @bindable value;

  constructor(element, ea) {
    this.element = element;
    this.ea = ea;
  }

  attached() {
    $(this.element).tooltip({
      title: this.value
    });

    this.subscription = this.ea.subscribe(LocaleChanged, m => {

    });
  }

  detaching() {
    this.subscription.dispose();
  }
}
